import { useEffect, useState } from "react"

export const getPagingRange = (current, { min = 0, total = 20, length = 5 } = {}) => {
  if (length > total) length = total;

  let start = current - Math.floor(length / 2);
  start = Math.max(start, min);
  start = Math.min(start, min + total - length);

  return Array.from({ length: length }, (el, i) => start + i);
}

export const getPaginationMsg = (currentPage, pageSize, totalNoOfRecords) => {
  if (!currentPage || !pageSize || !totalNoOfRecords) {
    return '';
  }
  const startCount = (currentPage * pageSize) - pageSize + 1;
  let endCount = null;
  if (currentPage * pageSize > totalNoOfRecords) {
    endCount = totalNoOfRecords;
  } else {
    endCount = currentPage * pageSize;
  }
  return `Showing ${startCount} - ${endCount} ${totalNoOfRecords ? 'of ' + totalNoOfRecords : ''}`
}

export const usePagination = ({ pageSize, records = [], forceRecordUpdate } = {}) => {
  const [state, setState] = useState({
    currentPage: 0,
    page: [],
    isLoading: false,
    isFirstPage: false,
    isLastPage: false,
    totalNoOfRecords: 0,
    pagingRange: [],
    paginationMessage: '',
  })


  useEffect(() => {
    if (records.length >= 0) {
      setState(state => ({ ...state, isLoading: true }))
      const reset = records.length != state.totalNoOfRecords || pageSize != state.pageSize
      calibrateState(reset)
    }
  }, [records?.length, pageSize, state?.currentPage, forceRecordUpdate])

  const calibratePage = (pageIndex) => {
    const page = []
    const currentPage = pageIndex
    const pageEndIndex = (currentPage * pageSize) + pageSize
    const isLastPage = pageEndIndex >= records.length
    const endIndex = isLastPage ? records.length : pageEndIndex
    for (let i = currentPage * pageSize; i < endIndex; i++) {
      page.push(records[i])
    }
    return page
  }

  const calibrateState = (reset) => {
    const currentPage = reset ? 0 : state.currentPage
    const pageEndIndex = (currentPage * pageSize) + pageSize
    const totalNoOfRecords = records.length
    const isLastPage = pageEndIndex >= totalNoOfRecords
    const isFirstPage = currentPage == 0
    const page = calibratePage(currentPage)

    setState((state) => ({
      ...state,
      page,
      isLastPage,
      isFirstPage,
      totalNoOfRecords,
      pageSize: pageSize,
      isLoading: false,
      currentPage,
      pagingRange: getPagingRange(currentPage, { min: 0, total: Math.ceil(totalNoOfRecords / pageSize), length: 5 }),
      paginationMessage: getPaginationMsg(currentPage + 1, pageSize, totalNoOfRecords),
    }))
  }

  const goToPage = ({ pageNo, toLastPage = false, toFirstPage = false } = {}) => {
    const lastPageNo = state.totalNoOfRecords > 0 ? Math.ceil(state.totalNoOfRecords / pageSize) - 1 : 0
    const firstPageNo = 0
    if (toLastPage) {
      setState((state) => ({ ...state, currentPage: lastPageNo }))
    } else if (toFirstPage) {
      setState((state) => ({ ...state, currentPage: firstPageNo }))
    } else if (pageNo >= 0) {
      setState((state) => ({ ...state, currentPage: pageNo }))
    }
  }

  const next = () => {
    if (state?.isLastPage) {
      Debug.hookLog('usePagination next -> Is last page')
    } else {
      setState((state) => ({ ...state, currentPage: state?.currentPage + 1 }))
    }
  }

  const previous = () => {
    if (state?.isFirstPage) {
      Debug.hookLog('usePagination next -> Is first page')
    } else {
      setState((state) => ({ ...state, currentPage: state?.currentPage - 1 }))
    }
  }


  return { ...state, next, previous, goToPage }
}